<div class="loading-spinner__container">
  @if (loadingObsAsSignal() || loadingSignal()) {
    <mat-spinner class="loading-spinner__spinner"></mat-spinner>
  }
  @if ((appState.isInErrorState$ | async) && loadingObsAsSignal() && loadingSignal() === false) {
    <div class="loading-spinner__message red">
      <mat-icon class="md-48">error_outline</mat-icon><br />
      Der skete en fejl.
    </div>
  }
  @if (hasNoData && loadingObsAsSignal() && loadingSignal() === false) {
    <div class="loading-spinner__message">
      <p>{{ noResultsMessage }}</p>
    </div>
  }
  @if ((loadingMessage && loadingObsAsSignal()) || loadingSignal() === true) {
    <div class="loading-spinner__message">
      <p>{{ loadingMessage }}</p>
    </div>
  }
</div>
